import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as mostFeaturedActions from '../actions';
import Slider from 'react-slick';
import Svg from 'rp-react-svg-icon';
import CarouselItem from '../components/Carousel/CarouselItem';
import CarouselArrow from '../components/Carousel/CarouselArrow';

export class MostFeatured extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isCarouselDragging: false
        };
    }

    render() {
        const {
            data,
        } = this.props;

        const carouselSettings = {
            dots: true,
            infinite: false,
            focusOnSelect: false,
            lazyLoad: true,
            swipeToSlide: true,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 4,
            initialSlide: 0,
            adaptiveHeight: false,
            beforeChange: () => this.setState({ isCarouselDragging: true }),
            afterChange: () => this.setState({ isCarouselDragging: false }),
            nextArrow: (
                <CarouselArrow slidesToShow={4} totalSlides={data.length} arrowSide={'right'} />
            ),
            prevArrow: (
                <CarouselArrow slidesToShow={4} totalSlides={data.length} arrowSide={'left'} />
            ),
            responsive: [
                {
                    breakpoint: 1278,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        initialSlide: 0,
                        arrows: false,
                        infinite: false,
                    },
                },
                {
                    breakpoint: 720,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        initialSlide: 0,
                        arrows: false,
                        infinite: false,
                    },
                },
                {
                    breakpoint: 484,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        initialSlide: 0,
                        arrows: false,
                        infinite: false,
                    },
                }
            ],
        };

        return (
            <div className="sb-featured">
                <span className="sb-featured__heading_wrapper_label">
                    <Svg iconName={'WBLogoH'} className="wb-logo-svg" />
                    <span className="sb-featured__heading_text">Featured Stallions</span>
                </span>
                <Slider {...carouselSettings}>
                    {
                        data.map((item) =>
                            <CarouselItem
                                key={item.horseUid}
                                item={item}
                                isCarouselDragging={this.state.isCarouselDragging}
                            />
                        )
                    }
                </Slider>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        data: state.stallion.mostFeaturedItems,
        isFetchingMostFeatured: state.stallion.isFetchingMostFeatured,
        error: state.stallion.mostFeaturedRequestFailed,
    };
}

export default connect(mapStateToProps, mostFeaturedActions)(MostFeatured);



// WEBPACK FOOTER //
// ./src/client/containers/MostFeatured.js